import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("smoor_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("smoor_token")) {
      localStorage.removeItem("smoor_token");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).join(" ");
  if (detail?.message) return detail.message;
  return err?.message || "Something went wrong";
}

export function apiReferences(err) {
  return err?.response?.status === 409 ? err?.response?.data?.detail?.references || null : null;
}

export async function getList(path, params = {}) {
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
  const res = await api.get(path, { params: clean });
  const total = Number(res.headers["x-total-count"] ?? res.data.length);
  return { items: res.data, total: Number.isNaN(total) ? res.data.length : total };
}

export async function downloadFile(path, filename, params = {}, mime = "application/octet-stream") {
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
  const res = await api.get(path, { params: clean, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: mime }));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export function downloadCsv(path, filename, params = {}) {
  return downloadFile(path, filename, params, "text/csv");
}

export default api;
